import React from 'react';
import {Box, Button, ButtonGroup, Divider, Grid, ListItem} from "@mui/material";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import {format, parse} from "date-fns";
import { useDispatch } from "react-redux";
import {setDealerActivities} from "../../../redux/actions/transactionActions";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    spaces: {
        display: 'flex',
        justifyContent: 'center'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
});

const ActivityReviewBox = ({activityInfo,activitySelection}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    return (
        <>
            <Box component="div" display={{ xs: 'block', sm: 'block' }}>
                <ListItem alignItems={"flex-start"} style={{padding:0, margin:0}}>
                    <Grid container direction="row" spacing={3} alignItems={"center"} justify={"center"}>
                        <Grid item sm={4} xs={12}>
                            <img src={activityInfo['image']} alt={activityInfo['name']} width={'100%'} className={'roomImage'}/>
                        </Grid>
                        <Grid item sm={3} xs={5}>
                            <Typography variant="h4" component="h4" align="center" >
                                {activityInfo['name']} - {format(parse(activitySelection['date'], "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'LLL d')} - {format(parse(activitySelection['date'], "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'h:mm a')}
                            </Typography>
                        </Grid>
                        <Grid item sm={2} xs={3}>
                            <div className={classes.spaces}>
                                <ButtonGroup size="small" aria-label="small outlined button group" className={'numBerths mini'}>
                                    <Button color="default" style={{width: 'auto'}} disabled>{activitySelection.pax}</Button>
                                </ButtonGroup>
                            </div>
                        </Grid>
                        <Grid item sm={3} xs={4} sx={{textAlign: 'center'}}>
                            <Typography variant="h4" component="h4" align="center">
                                <strong>${activitySelection.subtotal.formatMoney(2)}</strong>
                            </Typography>
                            <Button color={'secondary'} variant={'contained'} style={{ marginTop: 10 }} onClick={() =>
                                dispatch(
                                    setDealerActivities(
                                        activitySelection.company,
                                        activitySelection.id,
                                        activitySelection.availabilityId,
                                        null,
                                        false
                                    )
                                )
                            }>
                                Remove
                            </Button>
                        </Grid>
                    </Grid>
                </ListItem>
                <Divider variant="middle" className={'dividerFullWidth'} />
            </Box>
            
            <Box component="div" display={{ xs: 'none', sm: 'none' }}>
                <ListItem alignItems={"flex-start"}>
                    <Grid container direction="row" spacing={3} justifyContent={"space-around"}>
                        <Grid item sm={3}>
                            <Typography variant="h5" component="h5" align="center">
                                {activityInfo['name']} - {format(parse(activitySelection['date'], "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'LLL d')} - {format(parse(activitySelection['date'], "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'h:mm a')}
                            </Typography>
                        </Grid>
                        <Grid item sm={3} >
                            <ButtonGroup size="small" aria-label="small outlined button group" className={'numBerths mini'}>
                                <Button color="default" disabled>{activitySelection.pax}</Button>
                            </ButtonGroup>
                        </Grid>
                        <Grid item sm={3}>
                            <Typography variant="h5" component="h5" align="center">
                                ${activitySelection.subtotal.formatMoney(2)}
                            </Typography>
                            <Button color={'secondary'} variant={'contained'} style={{ marginTop: 10 }} onClick={() =>
                                dispatch(
                                    setDealerActivities(
                                        activitySelection.company,
                                        activitySelection.id,
                                        activitySelection.availabilityId,
                                        null,
                                        false
                                    )
                                )
                            }>
                                Remove
                            </Button>
                        </Grid>
                    </Grid>
                </ListItem>
                <Divider variant="middle" className={'dividerFullWidth'} />
            </Box>
        </>
    );
};

export default ActivityReviewBox;
